export const CO_GET_DELIVEREDON_LISTING = "CO_GET_DELIVEREDON_LISTING"
export const CO_GET_DELIVEREDON_LISTING_SUCCESS = "CO_GET_DELIVEREDON_LISTING_SUCCESS"
export const CO_GET_DELIVEREDON_LISTING_FAILED = "CO_GET_DELIVEREDON_LISTING_FAILED"
